import React, { useEffect,  useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import ColourChart from "../../../../components/Charts/ColourChart";
import {
  ColorMasterwise12Table,
  ColorMasterwise12TableFun,
  ColourFilter,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const Abc = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ColorMasterwise12TableData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);

  const DEFAULT_MONTH = "04";

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;
    console.log(year);

    return `${year}${monthValue}`; // ex: 202404
  };

  const MonthListdata = [
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
  ];
  const monthList = MonthListdata?.map((item) => ({
    label: item?.name,
    value: item?.value,
  }));

  const itemSubGroupList = ColourfilterData?.ItemSGroup?.map((item) => ({
    label: item?.ItemSubGroupName,
    value: item?.ItemSubGroupID,
  }));

  const [filters, setFilters] = useState({
    month: [],
    itemSubGroup: [],
  });

  const [search, setSearch] = useState({
    month: "",
    itemSubGroup: "",
  });

  useEffect(() => {
    dispatch(ColourFilter());

    const monthIds = getMonthId(DEFAULT_MONTH);

    dispatch(
      ColorMasterwise12Table({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ItemSubG: "",
        monthIds: monthIds,
      }),
    );
  }, [Firm, FinancialYear, dispatch]);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      let updatedSelected;

      if (type === "month") {
        updatedSelected = prev.month.includes(item.value) ? [] : [item.value];
      } else {
        const selected = prev[type];
        updatedSelected = selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value];
      }

      const newFilters = {
        ...prev,
        [type]: updatedSelected,
      };

      if (type === "itemSubGroup" || type === "month") {
        dispatch(ColorMasterwise12TableFun());
        const finalMonth = newFilters.month[0] || DEFAULT_MONTH;
        const monthIds = getMonthId(finalMonth);

        const payload = {
          FirmIDs: Firm,
          AcYearIDs: FinancialYear,
          ItemSubG: newFilters.itemSubGroup.join(","),
          monthIds: monthIds,
        };

        dispatch(ColorMasterwise12Table(payload));
      }

      return newFilters;
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, val) => {
    setSearch((prev) => ({ ...prev, [type]: val }));
  };

  const Detail1Columns = [
    {
      label: "Class",
      key: "class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "No of Item", key: "itemcount", align: "right" },
    { label: "Issue Quantity", key: "ConsQty", align: "right", format: "true" },
    { label: "Cost Value", key: "CostAmount", align: "right", format: "true" },
    { label: "Cons %", key: "ConsValuePct", align: "right", format: "true" },
    {
      label: "Prog. Cons %",
      key: "ProgressiveConsValuePct",
      align: "right",
      format: "true",
    },
  ];

  const Detail1Row = (ColorMasterwise12TableData?.Detail1 || []).map((row) => ({
    ...row,
  }));

  const DetailColumns = [
    {
      label: "Sr No",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Class",
      key: "Class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "Cons Qty", key: "ConsQty", align: "right", format: "true" },
    { label: "Cost Amount", key: "CostAmount", align: "right", format: "true" },
    {
      label: "Cons Value %",
      key: "ConsValuePct",
      align: "right",
      format: "true",
    },
    {
      label: "Prog. Cons %",
      key: "ProgressiveConsValuePct",
      align: "right",
      format: "true",
    },
  ];

  const DetailRow = (ColorMasterwise12TableData?.Detail || []).map(
    (row, index) => ({
      ...row,
    }),
  );

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ColorMasterwise12TableData || ColorMasterwise12TableData === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >


      {/* MOBILE */}
      <div className="d-lg-none text-end mb-2">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ColourFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(v) => handleSearch("month", v)}
              selectedItems={filters.month}
              toggleItem={(i) => toggleItem("month", i)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* FILTER 2 */}
            <ColourFilterBox
              title="Item Sub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(v) => handleSearch("itemSubGroup", v)}
              selectedItems={filters.itemSubGroup}
              toggleItem={(i) => toggleItem("itemSubGroup", i)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        <Col xl={3} lg={4} className="d-none d-lg-block" >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            
            <ColourFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(v) => handleSearch("month", v)}
              selectedItems={filters.month}
              toggleItem={(i) => toggleItem("month", i)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* FILTER 2 */}
            <ColourFilterBox
              title="Item Sub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(v) => handleSearch("itemSubGroup", v)}
              selectedItems={filters.itemSubGroup}
              toggleItem={(i) => toggleItem("itemSubGroup", i)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />

          </div>
        </Col>

        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* 🔷 lebal */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
            MACHINE COST CHART
            </div>

            {/* 🔷 BODY */}
            <div>
              <ColourChart
                data={ColorMasterwise12TableData?.Detail1 || []}
                labelKey="class"
                valueKey="Cost Amount"
              />
            </div>
          </div>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MACHINE GROUPWISE DETAIL
            </div>

            <ColourTable columns={Detail1Columns} data={Detail1Row} />
          </div>
          {/* 🔥 NORMAL TABLE */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MACHINE SUMMARY
            </div>

            <ColourTable columns={DetailColumns} data={DetailRow} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
